import { extend } from 'vee-validate';
import {
  required, digits, numeric, length,
} from 'vee-validate/dist/rules';
import IBAN from 'iban';
import { parseMoney } from '@/utils/format';

extend('required', {
  ...required,
  message: 'Required',
});

extend('iban', {
  validate: IBAN.isValid,
  message: 'Invalid IBAN',
});

extend('money', {
  validate(value) {
    const money = parseMoney(value);

    return !Number.isNaN(money);
  },
  message: 'Must be valid money input',
});

extend('amount', {
  validate(value, { min, max }: Record<string, any>) {
    const money = parseMoney(value);

    if (money === null) {
      return false;
    }

    return money >= min && money <= max;
  },
  params: ['min', 'max'],
  message: 'Must be between {min} and {max}',
});

extend('digits', digits);

extend('numeric', numeric);

extend('length', length);

extend('ref', {
  validate(value, { model }: Record<string, any>) {
    return {
      valid: model === '99' ? Boolean(!value) : Boolean(value),
      required: model !== '99',
    };
  },
  params: ['model'],
  computesRequired: true,
});
